import React, { Fragment, Suspense } from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import FreeAuthRoute from "./routes/FreeAuthRoute";
import PageNotFound from "./pages/PageNotFound";
import { routerData } from "./config/RoutesConfig";
import FrontLayout from "./layouts/front/FrontLayout";
import AdminLayout from "./layouts/auth/AdminLayout";
import { useAuth } from "./providers/AuthProvider";
import UserRoute from "./routes/UserRoute";
import AdminRoute from "./routes/AdminRoute";
import BlankLayout from "./layouts/BlankLayout";
import AuthRoute from "./routes/AuthRoute";
import LoadingFallback from "./components/elements/LoadingFallback";
import AdminNotAllowRoute from "./routes/AdminNotAllowRoute";

const CreateRoutes = () => {
  const { session } = useAuth();
  return (
    <Suspense fallback={<LoadingFallback />}>
      <ScrollToTop>
        <Routes>
          {(routerData(session?.user) || [])
            ?.filter((item) => !item?.disabled || item?.disabled === undefined)
            ?.map((route, i) => {
              let Layout = React.Fragment; // Default to no layout

              if (route.layout === "front") {
                Layout = FrontLayout;
              } else if (route.layout === "admin") {
                Layout = AdminLayout;
              } else if (!route.layout) {
                Layout = BlankLayout;
              }

              return (
                <Route
                  key={route?.key || i}
                  path={route.path}
                  element={
                    route?.routeType === "user" ? (
                      <UserRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </UserRoute>
                    ) : route?.routeType === "admin" ? (
                      <AdminRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </AdminRoute>
                    ) : route?.routeType === "auth" ? (
                      <AuthRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </AuthRoute>
                    ) : route?.routeType === "adminNotAllow" ? (
                      <AdminNotAllowRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </AdminNotAllowRoute>
                    ) : (
                      <FreeAuthRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </FreeAuthRoute>
                    )
                  }
                >
                  <Route
                    path={route?.path}
                    exact
                    element={<route.component />}
                  />
                  {route?.subRoute?.map((sub, j) => (
                    <Route
                      key={j?.toString()}
                      path={sub?.path}
                      exact
                      element={<sub.component />}
                    />
                  ))}
                </Route>
              );
            })}
          {/* 404 Page */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </ScrollToTop>
    </Suspense>
  );
};

export default CreateRoutes;
